import React from 'react';

import ReactPaginate from 'react-paginate';

import css from './Pagination.module.scss';

type PaginationProps = {
    pageCount: number;
    initialPage?: number;
    marginPagesDisplayed?: number;
    pageRangeDisplayed: number;
    customWrapper?: string;
    handlePageClick: (any) => void;
};

const Pagination = ({
    pageCount,
    marginPagesDisplayed,
    pageRangeDisplayed,
    initialPage,
    handlePageClick,
    customWrapper,
}: PaginationProps) => {
    const previousLabel = <img src="/front-static/icons/navigation/chevron-left-primary.svg" alt="previous" />;
    const nextLabel = <img src="/front-static/icons/navigation/chevron-right-primary.svg" alt="next" />;

    return (
        <>
            {pageCount && pageCount > 1 && (
                <div className={`${css.wrapper} ${customWrapper || ''}`}>
                    <ReactPaginate
                        containerClassName={css.container}
                        pageClassName={css.page}
                        pageLinkClassName={css.page__link}
                        activeClassName={css.page__active}
                        activeLinkClassName={css.page__link__active}
                        previousClassName={css.previous}
                        nextClassName={css.next}
                        previousLinkClassName={css.previous__link}
                        nextLinkClassName={css.next__link}
                        previousLabel={previousLabel}
                        nextLabel={nextLabel}
                        breakLabel={'...'}
                        breakClassName={css.break}
                        breakLinkClassName={css.break__link}
                        pageCount={pageCount}
                        marginPagesDisplayed={marginPagesDisplayed || 1}
                        pageRangeDisplayed={pageRangeDisplayed}
                        initialPage={initialPage || 0}
                        onPageChange={handlePageClick}
                    />
                </div>
            )}
        </>
    );
};

export default Pagination;
